import { useState, useEffect } from 'react';
import { logger } from '../utils/logger';

interface VersionInfo {
  version: string;
  shortVersion: string;
  fullVersion: string;
  buildDate: string;
  buildNumber: string;
  commitSha?: string;
  shortCommitSha?: string;
}

export const useVersion = () => {
  const [version, setVersion] = useState<VersionInfo | null>(null);
  const [loading, setLoading] = useState(false); // Não bloquear renderização inicial

  useEffect(() => {
    // Fazer fetch de forma não-bloqueante após renderização inicial
    const fetchVersion = async () => {
      try {
        // Usar requestIdleCallback se disponível, senão setTimeout
        const fetchData = async () => {
          try {
            const response = await fetch('/version.json', { 
              cache: 'no-cache' // Evitar cache para sempre buscar versão atual
            });
            if (response.ok) {
              const data = await response.json();
              setVersion(data);
            }
          } catch (error) {
            // Silenciosamente falha se o arquivo não existir (desenvolvimento local)
            logger.debug('Version file not found, skipping version display');
          } finally {
            setLoading(false);
          }
        };

        // Usar requestIdleCallback se disponível para não bloquear renderização
        if ('requestIdleCallback' in window) {
          (window as any).requestIdleCallback(fetchData, { timeout: 2000 });
        } else {
          // Fallback para setTimeout
          setTimeout(fetchData, 100);
        }
      } catch (error) {
        logger.debug('Error setting up version fetch:', error);
        setLoading(false);
      }
    };

    fetchVersion();
  }, []);

  return { version, loading };
};

